import React, { useState } from "react";
import Loader from "../../components/Loader/Loader";
import HeaderOne from "../../components/Header/HeaderOne";
import CTAOne from "../../components/CTA/CTAOne";
import FooterOne from "../../components/Footer/FooterOne";
import DataFetcher from "../../components/DataFetcher/DataFetcher";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

const API_URL = `${process.env.REACT_APP_API_BASE_URL}?op=press`;

const groupByPubname = (items) => {
  return items.reduce((acc, item) => {
    const pub = item.pubname || "Unknown Publication";
    if (!acc[pub]) acc[pub] = [];
    acc[pub].push({
      headline: item.headline || "No headline",
      date: item.date || "No date",
      link: item.link || "#",
    });
    return acc;
  }, {});
};

const PressAccordion = () => {
  const [searchTerm, setSearchTerm] = useState("");

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value.toLowerCase());
  };

  return (
    <DataFetcher url={API_URL}>
      {(data) => (
        <Loader>
          <HeaderOne />
          <section className="pt-100 mt-50">
            <div className="container my-5">
              <h2>Olshan in the Press</h2>

              {/* Search Field */}
              <div className="mb-4">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Filter by publication or headline..."
                  value={searchTerm}
                  onChange={handleSearchChange}
                />
              </div>

              {Array.isArray(data) && data.length > 0 ? (
                <div className="accordion" id="pressAccordion">
                  {Object.entries(groupByPubname(data))
                    .filter(([pubname, headlines]) => {
                      // Check if pubname or any headline contains the search term
                      return (
                        pubname.toLowerCase().includes(searchTerm) ||
                        headlines.some(h =>
                          h.headline.toLowerCase().includes(searchTerm)
                        )
                      );
                    })
                    .map(([pubname, headlines], idx) => (
                      <div className="accordion-item" key={idx}>
                        <h2 className="accordion-header" id={`heading-${idx}`}>
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target={`#collapse-${idx}`}
                            aria-expanded="false"
                            aria-controls={`collapse-${idx}`}
                          >
                            <h3>{pubname}</h3>
                          </button>
                        </h2>
                        <div
                          id={`collapse-${idx}`}
                          className="accordion-collapse collapse"
                          aria-labelledby={`heading-${idx}`}
                          data-bs-parent="#pressAccordion"
                        >
                          <div className="accordion-body">
                            <ul className="list-unstyled">
                              {headlines
                                .filter(h =>
                                  h.headline.toLowerCase().includes(searchTerm)
                                )
                                .map(({ headline, date, link }, i) => {
                                  const isExternal = link.startsWith("http");
                                  return (
                                    <li key={i} className="mb-3">
                                      <small className="text-muted d-block">
                                        {date !== "No date"
                                          ? new Date(date).toLocaleDateString()
                                          : date}
                                      </small>
                                      <a
                                        href={link}
                                        target={isExternal ? "_blank" : undefined}
                                        rel={isExternal ? "noopener noreferrer" : undefined}
                                      >
                                        <h4 className="red-color mt-0 mb-20">
                                          {headline}
                                        </h4>
                                      </a>
                                    </li>
                                  );
                                })}
                            </ul>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              ) : (
                <p>No press data available.</p>
              )}
            </div>
          </section>

          <CTAOne
            tagline="Olshan Luxury Report"
            title="Highly focused. Data Driven."
            textButton="GET THE LATEST LUXURY REPORT"
            linkButton="/market-report"
            bg="color"
          >
            This report is the only one of its kind. On a weekly basis, Olshan
            publishes a report covering all the contract activity in the luxury
            market on properties at $4 million and above.
          </CTAOne>

          <FooterOne />
        </Loader>
      )}
    </DataFetcher>
  );
};

export default PressAccordion;
